import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormControl } from '@angular/forms';
import { AuthenticationService } from '../../_services/index';
import {ToastrService} from 'ngx-toastr';

@Component({
    moduleId: module.id,
     selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
    model: any = {};
    loading = false;
    error = '';
    showForgotPassword = false;
    forgotForm: FormGroup;

    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private authenticationService: AuthenticationService,
        private toastr: ToastrService) { }

    ngOnInit() {
        // reset login status
        //this.authenticationService.logout();
        
        
        // CHECK THE isLoggedIn STATE HERE 
        if (this.authenticationService.isLoggedIn()) {
            setTimeout(()=>{    
                this.router.navigateByUrl('admin/projects/list');
            },1);
        }
        
        this.forgotForm = this.formBuilder.group({
            email: [null, [Validators.required, Validators.email], this.isRegisteredUser.bind(this)]
        })
    }
    
    toggleForgotPassword(boolean) {
        this.model = {};
        this.forgotForm.reset();
        this.error = '';
        this.showForgotPassword = boolean;
    }

    login() {
        this.loading = true;

        this.authenticationService.login(this.model.email, this.model.password)
            .subscribe(result => {
                if (result === true) {
                    this.router.navigateByUrl('/admin/projects/list');
                } else {
                    this.error = 'Email or password is incorrect';
                    this.loading = false;
                }
            });
    }
    
    isRegisteredUser(control: FormControl) { 
        const q = new Promise((resolve, reject) => {
            setTimeout(() => {
                this.authenticationService.isRegisteredUser(control.value, 1).subscribe(data => {
                    if(data) {
                        resolve(null);
                    } else { 
                        resolve({"isRegisteredUser": true})
                    }
                });
                
            }, 1000);
        });
        return q;
    }
    
    forgotPassword(form) {

        this.authenticationService.forgotPassword(form)
            .subscribe(result => {
                if (result > 0) {
                    this.forgotForm.reset();
                    this.toastr.success('Reset password link has been sent to your email address', 'Success');
                } else {
                    this.toastr.error('Everything is broken', 'Error', {
                        timeOut: 3000,
                    });
                }
            });
    }
}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/views/login/login.component.ts